export function CartItemsId(cart) {
    const itemsId = cart.items.map((e) => e.product.id);
    return itemsId;
}